import { useEffect } from "react";

interface Options {
  isHandlerActive: boolean;
  handleClickOutside: (ev: Event) => void;
  elementRef: React.RefObject<HTMLElement>;
}

export function useClickOutsideHandler({
  isHandlerActive,
  handleClickOutside, // Expected to be static
  elementRef,
}: Options) {
  useEffect(() => {
    if (!isHandlerActive) {
      // No handlers when not active
      return undefined;
    }

    const handleWindowClick = (event: Event) => {
      if (
        !elementRef.current ||
        elementRef.current.contains(event.target as Node)
      ) {
        return;
      }

      handleClickOutside(event);
    };

    window.addEventListener("click", handleWindowClick);
    return () => window.removeEventListener("click", handleWindowClick);
  }, [elementRef, handleClickOutside, isHandlerActive]);
}
